import React, { useState } from 'react';
import { UseFormReturn } from 'react-hook-form';
import { VerticalTabs } from './VerticalTabs';
import { DaySchedule } from './DaySchedule';
import { SlotsData } from 'interfaces/ISlots';

export type DaysNumber = "1" | "2" | "3" | "4" | "5" | "6" | "7";
 
const DAYS: {id: DaysNumber, label: string}[]= [
  { id: '1', label: 'Lunes' },
  { id: '2', label: 'Martes' },
  { id: '3', label: 'Miercoles' },
  { id: '4', label: 'Jueves' },
  { id: '5', label: 'Viernes' },
  { id: '6', label: 'Sabado' },
  { id: '7', label: 'Domingo' },
];

interface SourceScheduleProps {
  sourceIndex: number;
  deliveryIndex: number;
  form: UseFormReturn<SlotsData>;
}

export const SourceScheduleC: React.FC<SourceScheduleProps> = ({
  sourceIndex,
  deliveryIndex,
  form
}) => {
  const [activeTab, setActiveTab] = useState<DaysNumber>('1');

  const handleCloneDay = (toDay: DaysNumber) => {
    const fromDaySlots = form.getValues(`selectedStores.${sourceIndex}.schedule.${deliveryIndex}.deliverySlots.${activeTab}`) || [];
    form.setValue(`selectedStores.${sourceIndex}.schedule.${deliveryIndex}.deliverySlots.${toDay}`, fromDaySlots);
  };

  return (
    <div className="flex flex-row overflow-x-auto overflow-x-hidden w-full overflow-x-auto">
      <VerticalTabs
        days={DAYS}
        activeTab={activeTab}
        onTabChange={setActiveTab}
        onCloneDay={handleCloneDay}
      />
      
      <div className="flex-1">
        {DAYS.map(({ id }) => (
          <div
            key={id}
            className={activeTab === id ? 'block' : 'hidden'}
          >
            <DaySchedule 
              capacityId={`selectedStores.${sourceIndex}.dispatchCapacity`}
              scheduleId={`selectedStores.${sourceIndex}.schedule.${deliveryIndex}`}
              activeDay={activeTab === id ? activeTab : id}
              dayId={`selectedStores.${sourceIndex}.schedule.${deliveryIndex}.deliverySlots.${activeTab === id ? activeTab : id}`}
              form={form} 
            />
          </div>
        ))}
      </div>
    </div>
  );
};